import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Eye, Users, FileText, MessageSquare } from "lucide-react";

const Stat = ({ label, value, sub, icon: Icon }) => (
  <div className="border border-white/10 bg-ink-soft p-6 lg:p-8">
    <div className="flex items-center justify-between text-white/45 mb-4">
      <span className="overline">{label}</span>
      {Icon && <Icon size={16} strokeWidth={1.5} />}
    </div>
    <div className="font-serif text-gold text-4xl lg:text-5xl tabular-nums">{value}</div>
    {sub && <div className="mt-2 text-xs tracking-[0.2em] uppercase text-white/40">{sub}</div>}
  </div>
);

const AdminOverview = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/analytics/overview").then((r) => setData(r.data)).catch((e) => setError(formatApiError(e)));
  }, []);

  if (error) return <div className="text-red-400">{error}</div>;
  if (!data) return <div className="overline animate-pulse">…</div>;

  return (
    <div data-testid="admin-overview">
      <div className="overline mb-3">نظرة عامة</div>
      <h1 className="font-arabic font-black text-3xl sm:text-4xl text-bone mb-12">لوحة التحكم</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-14">
        <Stat label="زوار اليوم" value={data.visits.today} icon={Eye} />
        <Stat label="زوار الشهر" value={data.visits.month} icon={Eye} />
        <Stat label="زوار السنة" value={data.visits.year} icon={Eye} />
        <Stat label="الأعضاء" value={data.totals.members} icon={Users} />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-14">
        <Stat label="المقالات" value={data.totals.articles} icon={FileText} />
        <Stat label="منشور" value={data.totals.published} icon={FileText} />
        <Stat label="التعليقات" value={data.totals.comments} icon={MessageSquare} />
      </div>

      <h2 className="font-arabic font-bold text-xl text-bone mb-6">أكثر المقالات زيارة</h2>
      <div className="border border-white/10 bg-ink-soft divide-y divide-white/10">
        {(data.top_articles || []).length === 0 && (
          <div className="p-6 text-white/50 font-arabic">لا توجد بيانات بعد.</div>
        )}
        {(data.top_articles || []).map((a) => (
          <Link key={a.id} to={`/admin/articles`} className="flex items-center justify-between p-5 hover:bg-white/5 transition-colors">
            <div className="font-arabic text-bone truncate">{a.ar?.title || a.en?.title || a.slug}</div>
            <div className="text-gold tabular-nums">{a.views || 0}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminOverview;
